import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { NotificationService } from '../../notifications/notification.service'

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadImageComponent {
  imgBase64: string
  imgCroppedBase64: string
  cropperReady = false
  disableUpload = true
  firstCrop = true

  imgUrlVal: string
  supportedFiles = ['jpeg', 'jpg', 'png', 'gif']

  @Input() parent: FormGroup
  @Input() title: string
  @Input() placeholder: string
  @Input() round = true
  @Input() maintainAspectRatio = true
  @Output() upload = new EventEmitter<string>()
  @Output() imageChanged = new EventEmitter<any>()

  constructor(private notificationService: NotificationService) {
  }

  @Input() set imgUrl(val: string) {
    if (val) {
      this.imgUrlVal = val
      const xhr = new XMLHttpRequest()
      xhr.open('GET', this.imgUrlVal)
      xhr.responseType = 'blob'
      xhr.onload = () => this.fileChangeListener(xhr.response)
      xhr.send()
    }
  }

  fileChangeListener(file) {
    const myReader: FileReader = new FileReader()
    myReader.onloadend = (loadEvent: any) => {
      const result = loadEvent.target.result
      this.imgBase64 = result
      this.imageChanged.emit(result)
    }
    myReader.readAsDataURL(file)
  }

  uploadImage() {
    this.upload.emit(this.imgCroppedBase64)
    this.disableUpload = true
    this.firstCrop = true
  }

  onError(err: string) {
    this.notificationService.showInfoNotification('Warning', err)
  }

  imageCropped(image: string) {
    this.imgCroppedBase64 = image
    this.imageChanged.emit(image)
    if (this.firstCrop) {
      this.firstCrop = false
    } else {
      this.disableUpload = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/upload/upload-image/upload-image.component.ts